/* eslint-disable react/jsx-curly-newline */
import styled from "styled-components";
import { Carousel } from "react-responsive-carousel";
import { carouselCss } from "../../styles/carouselStyles";
import CustomImage from "../Image";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import { getUrlPath } from "../../utils/helpers";
import ArrowRightAltIcon from "../../assets/svgs/ArrowRightAltIcon";
import ArrowLeftAltIcon from "../../assets/svgs/ArrowLeftIcon";

const testimonials = [
	{
		id: 1,
		profile: {
			name: "Neeraj Gupta",
			designation: "City Head of Supply, Mumbai",
		},
		message: `Team apna has provided us with great support. 75% of
		our job fulfillment for delivery personnel has been
		through the apna. I love the skill tag feature as we
		don’t have to manually type requirements and the
		candidates we receive are already screened. Highly
		recommended, and no complaints!`,
		profileAvatarLink:
			"/cloudinary/home_page_images/shadowfox-testimonial-avatar.png",
		logoLink: "/cloudinary/home_page_images/shadowfax-logo.png",
	},
	{
		id: 2,
		profile: {
			name: "Dr. Varun Gupta",
			designation: "SVP - Medical Affairs",
		},
		message: `We are closely working with apna for talent discovery
		and hiring across job families. Their quickest
		turn-around time is enabling us to uninterruptedly
		continue our daily functions and services, especially
		during the present times.`,
		profileAvatarLink: "/cloudinary/home_page_images/1mg-testimonial-avatar.png",
		logoLink: "/cloudinary/home_page_images/1mg-logo.png",
	},
	{
		id: 3,
		profile: {
			name: "Navin Shah",
			designation: "Senior Recruiter",
		},
		message: `I would appreciate apna for supporting our
		organization in sourcing eligible candidates for
		different roles in different locations for our
		esteemed clients like D-Mart, Amazon, Thyssenkrup, and
		Jubilant. The apna portal is incredible.`,
		profileAvatarLink:
			"/cloudinary/home_page_images/teamlease-testimonial-avatar.png",
		logoLink: "/cloudinary/home_page_images/team_lease_logo_latest.png",
	},
];

const EmployerTestiomonials = ({ showHeading = false }) => {
	const arrowStyles = {
		position: "absolute",
		zIndex: 2,
		top: "calc(50% - 42px)",
		cursor: "pointer",
	};

	const handleTestimonialClick = (content) => {
		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Employer Testimonial click", {
				page: getUrlPath(),
				Source: "Home Page",
				actionType: "Intent Record",
				section: "employer testimonials",
				content,
			});
		});
	};

	const handleScrollEvent = () => {
		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Employer Testimonial scroll", {
				page: getUrlPath(),
				Source: "Home Page",
				actionType: "Intent Record",
				section: "employer testimonials",
			});
		});
	};

	return (
		<Container>
			{showHeading && (
				<HeadingContainer>
					<HeadingText>Employer Testimonials</HeadingText>
				</HeadingContainer>
			)}
			<DesktopContainer>
				<CarouselContainer>
					<Carousel
						showArrows
						showStatus={false}
						showThumbs={false}
						swipeable
						showIndicators={false}
						emulateTouch
						renderArrowNext={(onClickHandler, hasNext, label) =>
							hasNext && (
								<ArrowButtonContainer
									type="button"
									onClick={() => {
										handleScrollEvent();
										onClickHandler();
									}}
									title={label}
									style={{ ...arrowStyles, right: 60 }}
								>
									<ArrowRightAltIcon />
								</ArrowButtonContainer>
							)
						}
						renderArrowPrev={(onClickHandler, hasNext, label) =>
							hasNext && (
								<ArrowButtonContainer
									type="button"
									onClick={() => {
										handleScrollEvent();
										onClickHandler();
									}}
									title={label}
									style={{ ...arrowStyles, left: 60 }}
								>
									<ArrowLeftAltIcon />
								</ArrowButtonContainer>
							)
						}
					>
						{testimonials.map((t) => (
							<TestiomonialContainer
								key={t.profile.name}
								onClick={() => handleTestimonialClick(t.message)}
							>
								<ProfileAvatar>
									<CustomImage
										src={t.profileAvatarLink}
										height={220}
										width={220}
									/>
								</ProfileAvatar>
								<Divider />
								<div>
									<TestiominialMessage>{t.message}</TestiominialMessage>
									<Row>
										<div>
											<ProfileName>{t.profile.name}</ProfileName>
											<Designation>
												{`${t.profile.designation}`}
											</Designation>
										</div>
										<CompanyLogo>
											<CustomImage src={t.logoLink} layout="fill" />
										</CompanyLogo>
									</Row>
								</div>
							</TestiomonialContainer>
						))}
					</Carousel>
				</CarouselContainer>
			</DesktopContainer>
			<MobileContainer>
				<CarouselContainer>
					<Carousel
						showArrows
						showStatus={false}
						showThumbs={false}
						swipeable
						showIndicators={false}
						emulateTouch
						centerMode
						centerSlidePercentage={85}
					>
						{testimonials.map((t) => (
							<TestimonialContainerMobile
								key={t.profile.name}
								onClick={handleTestimonialClick}
							>
								<ProfileContainerMobile>
									<ProfileAvatar>
										<CustomImage
											src={t.profileAvatarLink}
											layout="fill"
										/>
									</ProfileAvatar>
									<AuthorProfileMobile>
										<div>
											<ProfileName>{t.profile.name}</ProfileName>
											<Designation>
												{t.profile.designation}
											</Designation>
										</div>
										<CompanyLogo>
											<CustomImage
												src={t.logoLink}
												// width={60}
												// height={30}
												layout="fill"
											/>
										</CompanyLogo>
									</AuthorProfileMobile>
								</ProfileContainerMobile>
								<TestiominialMessage>{t.message}</TestiominialMessage>
							</TestimonialContainerMobile>
						))}
					</Carousel>
				</CarouselContainer>
			</MobileContainer>
		</Container>
	);
};

export default EmployerTestiomonials;

const Container = styled.div`
	max-width: 1260px;
	margin: auto;
	margin-top: calc(100px - 30px);
`;

const HeadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	${mediaMaxWidth.medium`
		padding: 15px 0px;
	`}
`;
const HeadingText = styled.h2`
	font-size: 32px;
	font-weight: 900;
	line-height: 1.38;
	color: #373737;
	${mediaMaxWidth.medium`
		font-size: 24px;
	`}
`;

const TestiomonialContainer = styled.div`
	background: #ffffff;
	border: 3px solid #eaedf2;
	box-sizing: border-box;
	box-shadow: 0px 4px 24px 8px rgba(77, 57, 81, 0.1);
	border-radius: 12px;
	min-height: 317px;
	padding: 40px 138px;
	display: flex;
	align-items: center;
`;

const DesktopContainer = styled.div`
	display: block;
	${mediaMaxWidth.extraLarge`
		display: none;
	`}
`;

const MobileContainer = styled.div`
	display: none;
	${mediaMaxWidth.extraLarge`
		display: block;
	`}
`;

const TestimonialContainerMobile = styled.div`
	background: #ffffff;
	border: 1px solid #eaedf2;
	padding: 20px;
	box-shadow: 0px 4px 24px 8px rgba(77, 57, 81, 0.1);
	border-radius: 4px;
	height: 100%;
`;

const ProfileContainerMobile = styled.div`
	display: flex;
	align-items: center;

	> * + * {
		margin-left: 15px;
	}
`;

const AuthorProfileMobile = styled.div`
	display: flex;
	align-items: center;
	/* gap: 20px; */
	justify-content: space-between;
	flex-grow: 1;

	> * + * {
		margin-left: 20px;
	}
`;

const ProfileAvatar = styled.div`
	position: relative;
	min-width: 220px;
	height: 220px;

	${mediaMaxWidth.extraLarge`
		min-width: 80px;
		height: 80px;
	`}

	${mediaMaxWidth.medium`
		min-width: 48px;
		height: 48px;
	`}
`;

const Divider = styled.div`
	width: 1px;
	height: 194px;
	background: #dae0e5;
	margin: 36px;
`;

const TestiominialMessage = styled.p`
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: left;
	color: #31445a;
	margin-bottom: 0;
	${mediaMaxWidth.extraLarge`
		font-weight: normal;
		font-size: 20px;
		line-height: 1.3;
		margin-top: 16px;
		color: #31445A;
	`}
	${mediaMaxWidth.medium`
		font-weight: normal;
		font-size: 16px;
		line-height: 1.3;
		margin-top: 16px;
		color: #31445A;
	`}
	${mediaMaxWidth.extraExtraSmall`
		font-weight: normal;
		font-size: 12px;
		line-height: 14px;
		margin-top: 16px;
		color: #31445A;
	`}
`;

const ProfileName = styled.span`
	font-style: normal;
	font-weight: bold;
	font-size: 24px;
	line-height: 29px;
	display: flex;
	align-items: center;
	color: #4d3951;
	margin-bottom: 0;

	${mediaMaxWidth.medium`
		font-size: 16px;
		line-height: 16px;
		text-align: left;
	`}

	${mediaMaxWidth.extraExtraSmall`
		font-size: 12px;
		line-height: 14px;
	`}
`;

const Row = styled.div`
	margin-top: 18px;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Designation = styled.p`
	font-style: normal;
	font-weight: normal;
	font-size: 19px;
	line-height: 23px;
	display: flex;
	align-items: center;
	color: #6b7c8f;
	margin-top: 10px;
	margin-bottom: 0;

	${mediaMaxWidth.medium`
		font-size: 14px;
		line-height: 14px;
		text-align: left;
		margin-top: 5px;
	`}

	${mediaMaxWidth.extraExtraSmall`
		font-size: 12px;
		line-height: 1;
		margin-top: 5px;
		text-align: left;
	`}
`;

const CompanyLogo = styled.div`
	position: relative;
	margin-left: 16px;
	/* margin-top: 12px; */
	/* height: 80px; */
	width: auto;
	display: flex;
	/* align-self: flex-end; */
	height: 60px;
	width: 180px;

	img {
		object-fit: contain;
	}
	${mediaMaxWidth.medium`
		max-height: 54px;
		height: auto;
		width: auto;
		align-items: flex-end;
		margin-left: 0;
		height: 40px;
		width: 120px;
		margin-top: 0;
		display: flex;
		align-items: flex-end;
	`};

	${mediaMaxWidth.small`
		height: 30px;
		width: 90px;
	`}

	${mediaMaxWidth.extraExtraSmall`
		height: 20px;
		width: 60px;
	`}
`;

const CarouselContainer = styled.div`
	${carouselCss};
	.carousel .slide {
		background-color: transparent;
		padding: 30px;

		${mediaMaxWidth.large`
			padding: 30px 10px;
		`}/* padding: 20px; */
	}
`;

const ArrowButtonContainer = styled.div`
	width: 84px;
	height: 84px;
	border-radius: 5555px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #e8e1ea;

	${mediaMaxWidth.medium`
		height: 48px;
		width: 48px;
		margin-top: 24px;
	`}

	svg {
		color: #4d3951;
		height: 30px;
		width: 30px;
	}
`;
